import React, {MouseEvent, MouseEventHandler} from "react";
import {EstimateType} from "@estimate/types/estimate.types";
import {Button, Col, Row, Tab, Tabs} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faEuro,
    faInfoCircle,
    faScrewdriverWrench,
    faSpinner
} from "@fortawesome/pro-light-svg-icons";
import {
    EstimateInfoComponent as EstimateInfo, EstimateItemCreate, EstimateItemEdiUploadModal,
    EstimateItemFormInlineComponent as EstimateItemFormInline,
    EstimateItemListComponent as EstimateItemList, EstimateProcessInfo,
    EstimateSummaryComponent as EstimateSummary,
} from "@estimate/components";
import {faDownload} from "@fortawesome/pro-regular-svg-icons";
import {AxiosResponse} from "axios";
import {downloadFile} from "@src/helpers/utils.helper";
import {downloadEstimateFile} from "@estimate/utils/axios";
import {Maybe} from "@src/types/global.types";
import {useDispatch, useSelector} from "react-redux";
import {estimate as estimateState, showEstimateFileEdiUploadModal} from "@estimate/store/estimateSlice";
import {AppDispatch} from "@src/store";

interface EstimateCardProps{
    fetchEstimate: Function
}


const EstimateCardComponent: React.FC<EstimateCardProps> = (
    {fetchEstimate}
) => {
    const [isDownloadingEstimtePdf, setDownloadingEstimtePdf] = React.useState<boolean>(false);
    const estimate: Maybe<EstimateType> = useSelector(estimateState);
    const dispatch = useDispatch<AppDispatch>();

    const downloadEstimatePdfHandler: React.MouseEventHandler = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        if (isDownloadingEstimtePdf) {
            return;
        }

        setDownloadingEstimtePdf(true);
        downloadEstimateFile(estimate.id)
            .then((response: AxiosResponse<Blob>) => {
                const fileName = response.headers["content-disposition"]?.split(";")[1]?.replace(/filename=/g, "")
                    ?? 'kosztorys.pdf';
                downloadFile(response.data, fileName);
            })
            .finally(() => { setDownloadingEstimtePdf(false) })
    }

    return (
        <>
            <Row>
                <Col lg={6} className="mb-3">
                    <Tabs
                        defaultActiveKey="process"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                    >
                        <Tab eventKey="process"
                             title={<><FontAwesomeIcon icon={faScrewdriverWrench} fixedWidth={true}/> Proces serwisowy</>}
                        >
                            <EstimateProcessInfo process={estimate.process} />
                        </Tab>
                        <Tab eventKey="info"
                             title={<><FontAwesomeIcon icon={faInfoCircle} fixedWidth={true}/> Kosztorys</>}
                        >
                            <EstimateInfo estimate={estimate} />
                        </Tab>
                    </Tabs>
                </Col>
                <Col lg={6} className="mb-3">
                    <Tabs defaultActiveKey="summary" className="mb-3">
                        <Tab eventKey="summary"
                             title={<><FontAwesomeIcon icon={faEuro} fixedWidth={true}/> Podsumowanie</>}
                        >
                            <EstimateSummary estimate={estimate} />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
            <Row>
                <Col className="mb-3">
                    <Button variant={"outline-primary"} className={"mb-3"}
                        onClick={downloadEstimatePdfHandler}
                    >
                        {isDownloadingEstimtePdf ? (
                            <><FontAwesomeIcon icon={faSpinner} fixedWidth={true}/> pobieram kosztorys...</>
                        ) : (
                            <><FontAwesomeIcon icon={faDownload} fixedWidth={true}/> pobierz kosztorys</>
                        )}
                    </Button>
                    <EstimateItemList estimate={estimate} fetchEstimate={fetchEstimate}/>
                    <EstimateItemFormInline estimate={estimate} fetchEstimate={fetchEstimate}/>

                    <Row className={"align-items-center"}>
                        <Col xs={"auto"}>
                            <EstimateItemCreate estimate={estimate} afterSuccessSave={fetchEstimate} />
                        </Col>
                        {estimate.items.length === 0 && (
                            <>
                                <Col xs={"auto"}>lub</Col>
                                <Col xs={"auto"}>
                                    <Button variant={"outline-primary"} onClick={() => dispatch(showEstimateFileEdiUploadModal())}>
                                        Importuj plik EDI
                                    </Button>
                                </Col>
                            </>
                        )}
                    </Row>
                </Col>
            </Row>
        </>
    )
}

export default EstimateCardComponent;